// theme.js
const theme = {
    breakpoints: {
      //sm: '@media (min-width: 576px)',
      //md: '@media (min-width: 768px)',
      //lg: '@media (min-width: 992px)',
      xl: '@media (max-width: 1200px)',
      xl_1920: '@media (max-width: 1920px)',
      xl_2560: '@media (max-width: 2560px)',
    },
  };
  
  export default theme;
  